import { useState, useEffect } from "react"
import { useAtom } from 'jotai'

import {
  head,
  title,
  subTitle,
  body,
  text,
  stars,
  star,
  starActive,
  button,
  urls,
  url,
  urlWrap,
  copy,
  linkIcon,
  logo,
  balloon,
  balloonActive,
  errorText,
  tac
} from './style'
import { Button } from 'components/Button'
import { Spacer } from 'components/Spacer'
import { sessionIdAtom } from 'states'
import { usePost } from "hooks/usePost"
import { useFetchRequestlist } from "hooks/useFetchRequestlist"
import { Logo } from 'images/Logo'
import { Icon } from 'icons/Icon'

export const AfterCallFinish = () => {
  const [isPosted, setIsPosted] = useState<boolean>(false)
  const [level, setLevel] = useState<number>(0)
  const [isCopied, setIsCopied] = useState<boolean>(false)
  const [sessionId] = useAtom(sessionIdAtom)
  const { axiosPost, responseStatus } = usePost()
  const { requestlistData, requestlistErrorStatus } = useFetchRequestlist(sessionId)
  const [isRequestlistError, setIsRequestlistError] = useState<boolean>(false)
  const [errorStatus, setErrorStatus] = useState<number>()

  useEffect(() => {
    if (requestlistErrorStatus === 401) setIsRequestlistError(true)
    if (responseStatus === 200) {
      setIsPosted(true)
      setErrorStatus(200)
    } else if (responseStatus === 401) {
      setIsPosted(false)
      setErrorStatus(401)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [requestlistErrorStatus, responseStatus])

  const handlePost = () => {
    if (!level || isPosted) return

    const postData:object = {
      "level": level,
      "session_id": sessionId
    }
    axiosPost('/survey', postData)
  }
  const clickLevel = (value:number) => {
    if (isPosted) return
    // flienvieslh→sdkでサイトとクラス名が被らないように調整
    // finish level のアナグラムで生成
    const stars = [...(document.getElementsByClassName('flienvieslh') as HTMLCollectionOf<HTMLElement>)]
    if (stars.length) {
      for (let i = 0; i < stars.length; i++) {
        stars[i].classList.remove(starActive)
      }
      for (let i = 0; i < value; i++) {
        stars[i].classList.add(starActive)
      }
    }
    setLevel(value)
  }
  const copyToClipboard = () => {
    if (!requestlistData.requests.length) return
    setIsCopied(true)
    setTimeout(() => {
      setIsCopied(false)
    }, 2000)
    const value = requestlistData.requests.join(' , ')
    if (navigator.clipboard) {
      return navigator.clipboard.writeText(value)
    }
  }

  return (
    <>
      <div className={head}>
        <Icon name="Thanks" size={44} />
        <br />
        <p className={title}>ご利用ありがとうございました。</p>
        <Spacer size={3}/>
        <p className={subTitle}>またいつでもお気軽にご相談くださいませ。</p>
      </div>
      <div className={body}>
        <Spacer size={18}/>
        <p className={text}>オペレーターの対応の満足度を教えてください</p>
        <Spacer size={8}/>
        <div className={stars}>
          <div className={`${star} flienvieslh`} onClick={() => clickLevel(1)}></div>
          <Spacer size={4}/>
          <div className={`${star} flienvieslh`} onClick={() => clickLevel(2)}></div>
          <Spacer size={4}/>
          <div className={`${star} flienvieslh`} onClick={() => clickLevel(3)}></div>
          <Spacer size={4}/>
          <div className={`${star} flienvieslh`} onClick={() => clickLevel(4)}></div>
          <Spacer size={4}/>
          <div className={`${star} flienvieslh`} onClick={() => clickLevel(5)}></div>
        </div>
        <Spacer size={15}/>
        <Button
          onClick={() => handlePost()}
          size="medium"
          hasArrow={true}
          classname={button}
          disable={isPosted || !level}
        >
          {isPosted ? '送信済み' : '送信する'}
        </Button>
        {(errorStatus === 401) && (
          <>
            <Spacer size={5}/>
            <p className={errorText}>通信エラーにより、送信ができませんでした。</p>
          </>
        )}
        <Spacer size={20}/>
        <p className={text}>ご案内したurl</p>
        <Spacer size={10}/>
        {requestlistErrorStatus && isRequestlistError && (
          <p className={errorText}>通信エラーにより、送信ができませんでした。</p>
        )}
        {(!requestlistErrorStatus && requestlistData) && (
          <div className={urls}>
            {requestlistData.requests.map((request:string, index:number) => {
              return (
                <div key={index} className={urlWrap}>
                  <a href={request} target="_blank" rel="noopener noreferrer" className={url}>{request}</a>
                </div>
              )
            })}
            {!requestlistData.requests.length && <p className={`${text} ${tac}`}>リンクはありません</p>}
          </div>
        )}
        <Spacer size={24}/>
        {(!requestlistErrorStatus && !isRequestlistError) && !!requestlistData?.requests?.length && (
          <>
            <div className={copy} onClick={() => copyToClipboard()}>
              全てのリンクをコピー
              <Icon name="Link" size={14} className={linkIcon}/>
              <div className={`${balloon} ${isCopied ? balloonActive : ''}`}>コピーしました</div>
            </div>
            <Spacer size={23}/>
          </>
        )}
        <img src={Logo} className={logo} alt="Stage" />
      </div>
    </>
  );
}

